(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-detailed-adhoc-testing', {
            parent: 'app',
            url: '/download-detailed-adhoc-testing',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.entities.detailedAdhocTesting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-detailed-adhoc-testing/download-detailed-adhoc-testing.html',
                    controller: 'DownloadDetailedAdhocTestingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adhoc-testing');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                tests: ['Test', function (Test) {
                    return Test.getAllActiveAdhocTests();
                }],
            }
        });
    }

})();
